import Image from 'next/image';

import { Box, Flex, Heading, Text, useToken } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { Carousel } from '~/components/carousel';
import { QuoteIcon } from '~/components/quote-icon';

export type TestimonialsSectionProps = {
  title: string;
  testimonials: Array<{
    quote: string;
    name: string;
    title: string;
    imagePath: string;
  }>;
};

export function TestimonialsSection({ title, testimonials = [] }: TestimonialsSectionProps) {
  const [seafoam600] = useToken('colors', ['accent.sea-foam.600']);
  return (
    <Box as='section'>
      <Carousel
        scrollBarColorOverride={seafoam600}
        theme='light'
        title={title}
        titleAs='h2'
        titleSize='marketing-4xl'
        items={testimonials.map((testimonial) => (
          <Card
            key={testimonial.name}
            as='article'
            borderColor='gray.200'
            display='flex'
            flexDir='column'
            flexShrink={0}
            gap={4}
            minHeight='343px'
            padding={8}
            width={{ base: '370px', xl: '500px' }}
          >
            <Flex as='blockquote' flexDir='column' gap={6}>
              <QuoteIcon color='#047A65' />
              <Heading
                as='p'
                size='marketing-lg'
                sx={{
                  '&::after': {
                    content: '"\\201D"',
                  },
                }}
              >
                {testimonial.quote}
              </Heading>
            </Flex>
            <Flex alignItems='center' gap={4} marginTop='auto'>
              <Text display='flex' flexDir='column'>
                <Box as='span' color='accent.sea-foam.700' fontWeight='600'>
                  {testimonial.name}
                </Box>
                <Box as='span' fontSize='sm'>
                  {testimonial.title}
                </Box>
              </Text>
              <Box marginLeft='auto'>
                <Image alt='' height={64} src={testimonial.imagePath} width={64} />
              </Box>
            </Flex>
          </Card>
        ))}
        navButtonProps={{
          colorScheme: 'sea-foam',
        }}
      />
    </Box>
  );
}
